import { Button } from '@/atoms/Button'
import { AuthErrorBanner } from '@/molecules/AuthErrorBanner'
import { FormField } from '@/molecules/FormField'
import { useAgencyEditForm } from '@/modules/agencies/hooks/useAgencyEditForm'

export function AgencyEditForm() {
  const {
    name,
    slug,
    fieldErrors,
    submitError,
    isSubmitting,
    closeEdit,
    onNameChange,
    onSlugChange,
    onSubmit,
  } = useAgencyEditForm()

  return (
    <form className="flex flex-col gap-5" onSubmit={onSubmit} noValidate>
      <div className="flex flex-col gap-1">
        <p className="font-mono text-[0.7rem] uppercase tracking-[0.18em] text-muted">
          Edit agency
        </p>
        <h2
          id="edit-agency-heading"
          className="font-display text-2xl font-medium tracking-[-0.02em] text-ink"
        >
          Update details
        </h2>
        <p className="text-sm text-muted">
          Change the agency name or slug. More fields can be added later.
        </p>
      </div>

      <AuthErrorBanner message={submitError} />

      <FormField
        label="Name"
        name="name"
        value={name}
        placeholder="Northwind Agency"
        disabled={isSubmitting}
        error={fieldErrors.name ?? null}
        onChange={onNameChange}
      />

      <FormField
        label="Slug"
        name="slug"
        value={slug}
        placeholder="northwind-agency"
        disabled={isSubmitting}
        error={fieldErrors.slug ?? null}
        onChange={onSlugChange}
      />

      <div className="flex flex-wrap gap-3 pt-1">
        <Button type="submit" disabled={isSubmitting} className="min-w-36">
          {isSubmitting ? 'Saving…' : 'Save changes'}
        </Button>
        <Button
          type="button"
          variant="ghost"
          disabled={isSubmitting}
          onClick={closeEdit}
        >
          Cancel
        </Button>
      </div>
    </form>
  )
}
